"use client"

import { appendImageView2Params, getLinkPageUrl, isSafeUrl, titleFormat } from "@repo/shared"
import { IconFont } from "@repo/ui"
import React, { useRef, useState } from "react"
import { Carousel } from "antd"

import { NewsItem } from "../../../../../services/newscenter/interface"
import Style from "./NewsCarousel.module.scss"

interface NewsCarouselClientProps {
	items: NewsItem[]
}

export default function NewsCarouselClient({ items }: NewsCarouselClientProps) {
	const carouselRef = useRef<React.ComponentRef<typeof Carousel>>(null)
	const [activeIndex, setActiveIndex] = useState(0)

	if (items.length === 0) return null

	const handlePrev = () => {
		carouselRef.current?.prev()
	}

	const handleNext = () => {
		carouselRef.current?.next()
	}

	const handleDotClick = (index: number) => {
		if (index === activeIndex) return
		carouselRef.current?.goTo(index)
	}

	return (
		<div className={Style.carouselWrap}>
			<Carousel
				ref={carouselRef}
				autoplay
				autoplaySpeed={5000}
				effect="fade"
				dots={false}
				arrows={false}
				beforeChange={(_, next) => setActiveIndex(next)}
			>
				{items.map((item) => {
					const isSafe = isSafeUrl(item.source_url)
					const href = isSafe
						? getLinkPageUrl(item.source_url) + `-${titleFormat(item.title, { lower: true })}`
						: getLinkPageUrl(item.source_url)
					return (
						<div key={item.id} className={Style.carouselItem}>
							<a href={href} target="_blank" rel="noopener noreferrer" className={Style.carouselLink}>
								<div className={Style.carouselImage}>
									<img src={appendImageView2Params(item.thumb, "imageView2/1/w/800/h/400/q/100/format/webp")} alt="" />
								</div>
								<div className={Style.carouselTitleWrap}>
									<p>{item.title}</p>
								</div>
							</a>
						</div>
					)
				})}
			</Carousel>
			<button type="button" className={`${Style.arrow} ${Style.arrowPrev}`} onClick={handlePrev}>
				<IconFont type="icon-zuojiantou" className={Style.arrowIcon} />
			</button>
			<button type="button" className={`${Style.arrow} ${Style.arrowNext}`} onClick={handleNext}>
				<IconFont type="icon-youjiantou" className={Style.arrowIcon} />
			</button>
			<div className={Style.dots}>
				{items.map((item, index) => (
					<button
						type="button"
						key={item.id}
						className={`${Style.dot} ${index === activeIndex ? Style.dotActive : ""}`}
						onClick={() => handleDotClick(index)}
					/>
				))}
			</div>
		</div>
	)
}
